<template>
	<div >
		<el-dialog :visible.sync="loginWay1" class="login-popup" width='538px'>
			<div class="l-title">
				手机号登录
			</div>
			<div class="l-input">
				<div class="shu1 fl-al">
					<el-input  v-model="username" maxlength="11"  style="width: 100%;" placeholder="请输入手机号"></el-input>
				</div>
				<div class="shu1 fl-al">
					<el-input  v-model="yanzhengma" maxlength="11"  style="flex: 1;" placeholder="请输入图形验证码"></el-input>
					<img :src="codeUrl" @click="getPhotoCode" class="login-code-img" style="width:110px;height: 40px;margin-left: 20px;"/>
				</div>
				<div class="shu1 fl-al">
					<el-input  v-model="code" maxlength="6"  style="width: 100%;" placeholder="请输入验证码">
					</el-input>
					<div class="code-word" @click="getCode" :class="[countDown||!yanzhengma ? 'counting' : '']">{{getCodeText}}</div>
				</div>
			</div>
			<div class="all-bottom-btn" style="margin: 60px auto;width: 419px;height: 44px;" @click="loginPhoneCode">
				登录
			</div>
			<div class="l-xieyi fl-al">
				<img src="@/assets/icons/gray-gou.png" alt="" v-if="!daGou" @click="daGou = true">
				<img src="@/assets/icons/dagou.png" alt="" v-else @click="daGou = false">
				<div class="">
					我已阅读并同意<span @click="toAgreement('xieyi')">《用户协议》</span>  和 <span @click="toAgreement('yinsi')">《隐私政策》</span>
				</div>
			</div>
			<div class="more-way fl-al">
				<div class="heng-xian">
					
				</div>
				<span>更多登录方式</span>
				<div class="heng-xian">
					
				</div>
			</div>
			<div class="other-way fl-al">
				<div class="way-one fl-center-col" @click="chooseLoginWay(3)">
					<img src="@/assets/icons/wx-img.png" alt="">
					微信登录
				</div>
				<div class="way-one fl-center-col" @click="chooseLoginWay(2)">
					<img src="@/assets/icons/lock-img.png" alt="">
					密码登录
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="loginWay2" class="login-popup" width='538px' >
			<div class="l-title">
				账号密码登录
			</div>
			<div class="l-input">
				<div class="shu1 fl-al">
					<el-input  v-model="username" maxlength="11"  style="width: 100%;" placeholder="请输入手机号"></el-input>
				</div>
				<div class="shu1 fl-al">
					<el-input  v-model="password" maxlength="25"  style="width: 100%;" placeholder="请输入密码" show-password></el-input>
				</div>
			</div>
			<div class="all-bottom-btn" style="margin: 60px auto;width: 419px;height: 44px;" @click="loginPassword">
				登录
			</div>
			<div class="l-xieyi fl-al">
				<img src="@/assets/icons/gray-gou.png" alt="" v-if="!daGou" @click="daGou = true">
				<img src="@/assets/icons/dagou.png" alt="" v-else @click="daGou = false">
				<div class="">
					我已阅读并同意<span @click="toAgreement('xieyi')">《用户协议》</span>  和 <span @click="toAgreement('yinsi')">《隐私政策》</span>
				</div>
			</div>
			<div class="more-way fl-al">
				<div class="heng-xian">
					
				</div>
				<span>更多登录方式</span>
				<div class="heng-xian">
					
				</div>
			</div>
			<div class="other-way fl-al">
				<div class="way-one fl-center-col" @click="chooseLoginWay(1)">
					<img src="@/assets/icons/phone-img.png" alt="">
					手机登录
				</div>
				<div class="way-one fl-center-col" @click="chooseLoginWay(3)">
					<img src="@/assets/icons/wx-img.png" alt="">
					微信登录
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="loginWay3" class="login-popup" width='538px' append-to-body>
			<div class="l-title">
				微信登录
			</div>
			<div class="l-erweima" >
				<!-- <img src="" alt="" /> -->
				<div id="login_container"></div>
			</div>
			<div class="more-way fl-al">
				<div class="heng-xian">
					
				</div>
				<span>更多登录方式</span>
				<div class="heng-xian">
					
				</div>
			</div>
			<div class="other-way fl-al">
				<div class="way-one fl-center-col" @click="chooseLoginWay(1)">
					<img src="@/assets/icons/phone-img.png" alt="">
					手机登录
				</div>
				<div class="way-one fl-center-col" @click="chooseLoginWay(2)">
					<img src="@/assets/icons/lock-img.png" alt="">
					密码登录
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { exitLoginApi,codeLoginApi,passwordLoginApi,getCodeApi,userInfoApi,getCodeImgApi } from '@/api/user/user';
	import { Toast,debounceNew } from '@/utils/index';
	import { mapState, mapActions } from 'vuex';
	export default {
		name: 'CommonHead',
		props: {
		  userInfo:Object
		},
		components: {
		},
		data() {
			return {
				password:'',
				username:'',
				code:'',
				getCodeText:'获取验证码',
				countDown:'',
				Timer:'',
				daGou:false,
				loginWay1:false,//1验证码 2密码 3微信
				loginWay2:false,//1验证码 2密码 3微信
				loginWay3:false,//1验证码 2密码 3微信
				yanzhengma:'',//图片验证码
				codeUrl:'',//验证码
				yz_uuid:'',
			}
		},
		created() {
		},
		watch:{
			loginWay1(newVal){
				if(newVal){
					this.getPhotoCode()
				}
			},
			loginWay3(newVal){
				if(newVal){
					this.$nextTick(()=>{
						this.initSDK()
					})
				}
			},
		},
		methods: {
			...mapActions(['login', 'logout']),
			initSDK(){
			  // eslint-disable-next-line no-undef,no-unused-vars
			  const obj = new WxLogin({
			    self_redirect: false,
			    id: "login_container",
			    appid: "wx06ba5771b508cc3f",
			    scope: "snsapi_login",
			    redirect_uri: "https://www.jiafenmao.online",	// 要与上面的回调域名一致，域名后的路径/data不作要求
			    state: "",										// 防止xss攻击手段，回调的时候会带回来，回调的时候校验一下最好
			    style: "",
			    href: "data:text/css;base64,LmxvZ2luUGFuZWwubm9ybWFsUGFuZWwgLnRpdGxlIHsNCgkgIGRpc3BsYXk6IG5vbmU7DQoJfQ0KCS5xcmNvZGUubGlnaHRCb3JkZXIgew0KCSAgd2lkdGg6IDI0OHB4Ow0KCSAgaGVpZ2h0OiAyNDhweDsNCgkgIG1hcmdpbi10b3A6IDA7DQoJICBib3gtc2l6aW5nOiBib3JkZXItYm94Ow0KCX0NCgkuaW1wb3dlckJveCAuaW5mbyB7DQoJICBkaXNwbGF5OiBub25lOw0KCX0NCgkud2ViX3FyY29kZV90eXBlX2lmcmFtZSB7DQoJICB3aWR0aDogMjQ4cHg7DQoJfQ=="
			  });
			},
			chooseLoginWay(i){
				this.loginWay1 = false
				this.loginWay2 = false
				this.loginWay3 = false
				this[`loginWay${i}`] = true
			},
			toAgreement(i){
				this.loginWay1 = false
				this.loginWay2 = false
				this.loginWay3 = false
				this.$router.push({
					path: 'agreement?what='+i
				});
			},
			// 获取图形验证码
			getPhotoCode() {
			  getCodeImgApi().then(res => {
				  console.log(res);
				if(res.code === 200){
					this.codeUrl = "data:image/gif;base64," + res.data.img;
					this.yz_uuid = res.data.uuid
				}else{
					Toast(data.msg,'error')
				}
			  });
			},
			// 验证码登录
			loginPhoneCode:debounceNew(async function(){
				if(!this.check.telphone(this.username)) {
					// return Toast("请填写手机号",'error')
					return false
				}
				if(!this.check.code(this.code)) {
					// return Toast("请填写手机号",'error')
					return false
				}
				if(!this.daGou){
					return Toast("请阅读并同意用户协议、隐私政策",'error')
				}
				const data = await codeLoginApi({
					phonenumber:this.username,
					smsCode:this.code,
					// cid: clientid,
					// loginDeviceCode:uni.getStorageSync('phoneIos')?clientid:this.oaId, //登录设备编码
					// loginDeviceModel:uni.getStorageSync('phoneModel') //登录设备型号
				})
				if(data.code == 200){
					localStorage.setItem('token', data.data.token);
					await userInfoApi().then(res=>{
						console.log(res);
						Toast('登录成功')
						const { nickName, phone, userId, avatar } = res.data || {};
						const info = {nickName,phone,userId,avatar}
						localStorage.setItem('userInfo',JSON.stringify(info));
						this.login(info)
						setTimeout(()=>{
							this.loginWay1 = false
						},300)
					})
				}else{
					Toast(data.msg,'error')
				}
			},1500),
			// 密码登录
			loginPassword:debounceNew(async function(){
				if(!this.check.telphone(this.username)) {
					// return Toast("请填写手机号",'error')
					return false
				}
				if(!this.password) {
					return Toast("请输入密码",'error')
				}
				if(!this.daGou){
					return Toast("请阅读并同意用户协议、隐私政策",'error')
				}
				const data = await passwordLoginApi({
					username: this.username,
					password: this.password,
					// cid: clientid,
					// loginDeviceCode:uni.getStorageSync('phoneIos')?clientid:this.oaId, //登录设备编码
					// loginDeviceModel:uni.getStorageSync('phoneModel') //登录设备型号
				})
				if(data.code == 200){
					localStorage.setItem('token', data.data.token);
					await userInfoApi().then(res=>{
						console.log(res);
						Toast('登录成功')
						const { nickName, phone, userId, avatar } = res.data || {};
						const info = {nickName,phone,userId,avatar}
						localStorage.setItem('userInfo',JSON.stringify(info));
						this.login(info)
						setTimeout(()=>{
							this.loginWay2 = false
						},300)
					})
				}else{
					Toast(data.msg,'error')
				}
			},1500),
			async getCode() {
				if(!this.check.telphone(this.username)) {
					return false
				}
				if(!this.yanzhengma) {
					return Toast('请先输入图形验证码','error')
				}
				if (this.countDown == false) {
					let pams = {
						phone:this.username,
						code:this.yanzhengma,
						uuid:this.yz_uuid
					}
					const data = await getCodeApi(this.username,this.yanzhengma,this.yz_uuid)
					if(data.code == 200){
						Toast('已发送')
						console.log('获取验证码');
						this.setTimer()
					}else{
						Toast(data.msg,'error')
						this.getPhotoCode()
					}
				}
			},
			setTimer() {
				let holdTime = 60;
				this.countDown = true;
				this.Timer = setInterval(() => {
			
					if (holdTime <= 0) {
						this.countDown = false;
						// this.warningCodeText = "短信验证码已失效，请重新获取";
						this.getCodeText = "获取验证码";
						this.verification = ''
						clearInterval(this.Timer);
						return;
					}
					this.getCodeText = holdTime + "s 后再获取";
					holdTime--;
				}, 1000);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.login-popup{
		// width: 538px;
		// height: 608px;
		// background-color: #fff;
		.l-title{
			font-weight: 500;
			font-size: 18px;
			color: #333333;
			text-align: center;
		}
		.l-erweima{
			width: 248px;
			height: 248px;
			margin: 40px auto;
			// background-color: pink;
		}
		.l-input{
			margin-top: 40px;
			.shu1{
				width: 419px;
				height: 50px;
				margin: 16px auto;
				position: relative;
				.code-word{
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #28A9EE;
					position: absolute;
					right: 16px;
					cursor: pointer;
				}
				.counting{
					color: #999;
					cursor:not-allowed;
				}
				input{
					height: 50px;
					width: 80%;
					border: none;
				}
			}
		}
		.l-xieyi{
			margin: 12px auto;
			margin-left: 46px;
			img{
				width: 16px;
				height: 16px;
				margin-right: 11px;
				cursor: pointer;
			}
			font-size: 10px;
			color: #999999;
			span{
				color: #01BF5C;
				cursor: pointer;
			}
		}
		.more-way{
			margin: 60px auto;
			font-size: 12px;
			color: #999999;
			width: fit-content;
			.heng-xian{
				background-color: #999;
				width: 40px;
				height: 1px;
			}
			span{
				margin:0 9px;
				height: 17px;
			}
		}
		.other-way{
			width: fit-content;
			margin: 18px auto;
			font-size: 12px;
			color: #999999;
			.way-one{
				width: 65px;
				text-align: center;
				cursor: pointer;
				img{
					width: 65px;
					height: 65px;
					margin-bottom: 7px;
				}
			}
			.way-one:first-child{
				margin-right: 48px;
			}
		}
	}
</style>